import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-screenshot',
  templateUrl: './screenshot.component.html',
  styleUrls: ['./screenshot.component.css']
})
export class ScreenshotComponent {
  @ViewChild('container') 'container': ElementRef;
  @ViewChild('screenshot') 'screenshot': ElementRef;
  zoomInPercentage = 100;
  imageSource = '';
  isZoomed = false;
  pos = { top: 0, left: 0, x: 0, y: 0 };

  constructor(public dialogRef: MatDialogRef<ScreenshotComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    if (this.data && this.data.url) {
      this.imageSource = this.data.url;
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  onClick(e: any) {
    this.isZoomed = !this.isZoomed;
    if (this.isZoomed) {
      this.container.nativeElement.style.overflow = 'auto';
      this.screenshot.nativeElement.style.width = '300%';
      this.screenshot.nativeElement.style.cursor = 'zoom-out';
      this.screenshot.nativeElement.style.cursor = 'zoom-out';
      this.screenshot.nativeElement.style.left = `-${e.clientX}`;
      this.screenshot.nativeElement.style.top = `-${e.clientY}`;
    } else {
      this.container.nativeElement.style.overflow = 'hidden';
      this.screenshot.nativeElement.style.width = '100%';
      this.screenshot.nativeElement.style.cursor = 'zoom-in';
    }
  }

  zoomInClick() {
    if (this.zoomInPercentage <= 1000) {
      this.zoomInPercentage = 100 + this.zoomInPercentage;
      this.container.nativeElement.style.overflow = 'auto';
      this.screenshot.nativeElement.style.width = this.zoomInPercentage + '%';
      this.screenshot.nativeElement.style.cursor = 'zoom-out';
      this.screenshot.nativeElement.style.cursor = 'zoom-out';
    }
  }

  zoomOutClick() {
    if (this.zoomInPercentage >= 200) {
      this.zoomInPercentage = this.zoomInPercentage - 100;
      this.container.nativeElement.style.overflow = 'auto';
      this.screenshot.nativeElement.style.width = this.zoomInPercentage + '%';
      this.screenshot.nativeElement.style.cursor = 'zoom-out';
      this.screenshot.nativeElement.style.cursor = 'zoom-out';
    }
  }

  reset() {
    this.zoomInPercentage = 100;
    this.container.nativeElement.style.overflow = 'hidden';
    this.screenshot.nativeElement.style.width = this.zoomInPercentage + '%';
    this.screenshot.nativeElement.style.cursor = 'zoom-in';
    this.screenshot.nativeElement.style.cursor = 'zoom-in';
  }

  onMouseDown(e: any) {
    this.pos = {
      left: this.container.nativeElement.scrollLeft,
      top: this.container.nativeElement.scrollTop,
      x: e.clientX,
      y: e.clientY,
    };
  }

  mouseMoveHandler(e: any) {
    const dx = (e.clientX - this.pos.x) * 2;
    const dy = (e.clientY - this.pos.y) * 3;
  }

  onLeave() {
    this.container.nativeElement.style.overflow = 'hidden';
    this.screenshot.nativeElement.style.transform = 'scale(1)';
    this.screenshot.nativeElement.style.cursor = 'zoom-in';
  }
}
